exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".icon-button{cursor:pointer;color:#2c2c2c;background-color:#ebebeb;padding:4px 8px;border:none;border-radius:4px}.icon-button img{margin-right:4px}.icon-button:hover{transition:.3s ease-in-out;background-color:#e1e1e1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Buttons/IconButton/IconButton.scss
// module id = 1527
// module chunks = 0